import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Shield, AlertTriangle, Users, Ban, BadgeCheck } from 'lucide-react';

export default function AdminDashboard() {
  const location = useLocation();

  const navItems = [
    { name: '總覽首頁', path: '/admin', icon: Shield, exact: true },
    { name: '檢舉管理', path: '/admin/reports', icon: AlertTriangle },
    { name: '用戶管理', path: '/admin/users', icon: Users },
    { name: '活動推薦', path: '/admin/event-recommendations', icon: BadgeCheck },
    { name: '封鎖管理', path: '/admin/blocked', icon: Ban },
  ];

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f8fafc',
      paddingBottom: '80px'
    }}>
      {/* Admin Header */}
      <div style={{
        background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
        padding: '24px 20px',
        color: 'white',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        position: 'sticky',
        top: 0,
        zIndex: 50
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Shield style={{ color: '#6a9fd3' }} size={28} />
          <h1 style={{ fontSize: '1.5rem', fontWeight: '800', margin: 0 }}>管理員後台</h1>
        </div>
        
        {/* Navigation Tabs */}
        <div style={{ maxWidth: '1200px', margin: '20px auto 0', display: 'flex', gap: '16px', overflowX: 'auto' }}>
          {navItems.map(item => {
            const isActive = item.exact ? location.pathname === item.path : location.pathname.startsWith(item.path);
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '10px 16px',
                  background: isActive ? 'rgba(255,255,255,0.15)' : 'transparent',
                  color: isActive ? '#6a9fd3' : '#cbd5e1',
                  borderRadius: '12px',
                  textDecoration: 'none',
                  fontWeight: '600',
                  fontSize: '15px',
                  transition: 'all 0.2s',
                  border: isActive ? '1px solid rgba(251,191,36,0.3)' : '1px solid transparent'
                }}
              >
                <Icon size={18} />
                {item.name}
              </Link>
            );
          })}
        </div>
      </div>

      {/* Content Area */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '24px 16px' }}>
        <Outlet />
      </div>
    </div>
  );
}
